import Integration from "../integration/Integrations";
import { Tag } from "./Tag";
var analyticsErrorCodeMap = new Map();
analyticsErrorCodeMap.set("PURCHASABILITY_UNAPPROVED", "UNAPPROVED_ITEM");
analyticsErrorCodeMap.set("PURCHASABILITY_OTHER", "OTHER_ITEM");
var PRODUCTS_SELECTOR = '[data-analytics-type="cart-product"]';
var UNAPPROVED_PRODUCTS_SELECTOR = PRODUCTS_SELECTOR + ' [data-analytics-error-types="PURCHASABILITY_UNAPPROVED"]';
var UNPURCHASABLE_PRODUCTS_SELECTOR = PRODUCTS_SELECTOR + ' [data-analytics-error-types="PURCHASABILITY_OTHER"]';
var ORDER_BUTTON_SELECTOR = '[data-analytics-id="cart-order-button"]';
var pushCartLoadedEvent = function (numItems, numUnapprovedItem, numUnavailableItem) {
    Integration.submitAnalyticEvent({
        eventName: "cartLoaded",
        eventData: {
            numItems: numItems,
            numUnapprovedItem: numUnapprovedItem,
            numUnavailableItem: numUnavailableItem
        },
        page: document.location.pathname
    }).catch(function (reason) { return console.warn("Analytic event submission failed with reason [".concat(reason, "]")); });
};
var pushCartRemoveItemEvent = function (productCode, errorCode) {
    Integration.submitAnalyticEvent({
        eventName: "cartRemoveItem",
        eventData: {
            productCode: productCode,
            errorCode: analyticsErrorCodeMap.get(errorCode)
        },
        page: document.location.pathname
    }).catch(function (reason) { return console.warn("Analytic event submission failed with reason [".concat(reason, "]")); });
};
var pushCartCheckoutEvent = function (numItems) {
    Integration.submitAnalyticEvent({
        eventName: "cartCheckout",
        eventData: {
            numItems: numItems
        },
        page: document.location.pathname
    }).catch(function (reason) { return console.warn("Analytic event submission failed with reason [".concat(reason, "]")); });
};
var registerRemoveButtonEvent = function (button) {
    button.addEventListener("click", function () {
        var productCode = button.getAttribute("data-productid");
        var errorCode = button.getAttribute("data-analytics-error-types");
        if (productCode != null && errorCode != null) {
            pushCartRemoveItemEvent(productCode, errorCode);
        }
    });
};
var registerOrderButtonsClickHandler = function () {
    getNodes(ORDER_BUTTON_SELECTOR).map(function (btn) {
        btn.addEventListener("click", function () {
            pushCartCheckoutEvent(getProducts().length);
        });
    });
};
var registerRemoveButtonEvents = function () {
    getUnApprovedProducts().map(function (btn) {
        registerRemoveButtonEvent(btn);
    });
    getUnPurchasableProducts().map(function (btn) {
        registerRemoveButtonEvent(btn);
    });
};
var productsExist = function () {
    return getProducts().length > 0;
};
var orderButtonExists = function () {
    return getNodes(ORDER_BUTTON_SELECTOR).length > 0;
};
var getNodes = function (query) {
    return Array.from(document.querySelectorAll(query));
};
var getProducts = function () {
    return getNodes(PRODUCTS_SELECTOR);
};
var getUnApprovedProducts = function () {
    return getNodes(UNAPPROVED_PRODUCTS_SELECTOR);
};
var getUnPurchasableProducts = function () {
    return getNodes(UNPURCHASABLE_PRODUCTS_SELECTOR);
};
export var maXCheckoutApplicationProductEventsTag = new Tag(function () {
    var orderButtonClickEventAdded = false;
    var productEventsHandled = false;
    var repeatUntilProductsProcessed = setInterval(function () {
        if (!orderButtonClickEventAdded && orderButtonExists()) {
            registerOrderButtonsClickHandler();
            orderButtonClickEventAdded = true;
        }
        if (!productEventsHandled && productsExist()) {
            registerRemoveButtonEvents();
            pushCartLoadedEvent(getProducts().length, getUnApprovedProducts().length, getUnPurchasableProducts().length);
            productEventsHandled = true;
        }
        if (orderButtonClickEventAdded && productEventsHandled) {
            clearInterval(repeatUntilProductsProcessed);
        }
    }, 1000);
});
